document.addEventListener('DOMContentLoaded', () => {
  const desktopDetails = [...document.querySelectorAll('.crg-nav__item')];
  const mobileDetails = [...document.querySelectorAll('.crg-nav__mobile-item')];
  const allDetails = [...desktopDetails, ...mobileDetails];

  allDetails.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      allDetails.forEach((other) => { if (other !== item) other.open = false; });
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.crg-nav')) return;
    allDetails.forEach((item) => { item.open = false; });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    allDetails.forEach((item) => { item.open = false; });
  });
});
